<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/179IO4R/tc-custom/9781601635419.jpg?1695244608548" alt="This image is the cover for the book Young Professional's Guide to Managing"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Young Professional's Guide to Managing
      </h1>
      <p class="bookDescription body article font2">
        <p>One of the hardest challenges in anyone’s career is transitioning from being a employee responsible solely for one’s own work to a manager responsible for others’ performance. New managers face the stress of giving up control while needing to drive results through others.Many of the more than 80 million members of the Millennial generation are facing the challenge of managing others without a guide to success specifically tailored to them.The Young Professional’s Guide to Managing fills this void with a mix of relevant tips and stories, and a connection to rich online resources. It is an essential guide for all new managers and emerging leaders, providing important insights, including:How to successfully transition to being a manager, from the very first dayThe 10 skills all young professionals must develop to thrive as STAR managersManaging people of different generationsHow to hire, develop, and lead teams to incredible resultsAdvanced strategies for young managers, including how to fire underperforming employees and how to squash office politics.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Aaron McDaniel, Jim Kouzes
      </h2>
      
      <p class="authorDescription body article">Aaron McDaniel is a corporate manager, entrepreneur, author, public speaker, and community leader. He has held management roles in business development, strategy, marketing, customer service, operations, and sales at AT&T. Aaron wrote The Young Professional’s Guide to the Working World and created SparkSource, the online community that reinvents career mentoring. He is also the founder of multiple entrepreneurial ventures, including e-commerce and mobile application development companies. A graduate of UC Berkeley’s Undergraduate Haas School of Business, Aaron instructed a highly rated student-led course on leadership and has spoken at some of the nation’s top universities and companies. Passionate about giving back, he founded the Jill Wakeman Foundation for Equality and is an active community volunteer in San Francisco, where he lives.Jim Kouzes is the coauthor of the award-winning and best-selling book The Leadership Challenge.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Career Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6b4604f2